import ymaps from "ymaps";

require('./all')

//scss
import '../../scss/site/contacts.scss'
//

const bootstrap_collapse = require('bootstrap/js/dist/collapse');

var nav = document.getElementById('nav-menu-box')

nav.addEventListener('show.bs.collapse', function () {
    nav.parentElement.parentElement.parentElement.classList.add('show')
})

nav.addEventListener('hide.bs.collapse', function () {
    nav.parentElement.parentElement.parentElement.classList.remove('show')
})

//Map
ymaps.load('https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=ef210d1b-2bed-4cdb-be6f-1a0f9f88ac0e')
    .then(maps => {

        var mapbox = document.getElementById('map'),
            coords = mapbox.getAttribute('coords'),
            set = coords.split(','),
            zoom = set[2]

        const ymap = new maps.Map('map', {
            center: [parseFloat(set[0]), parseFloat(set[1])],
            type: 'yandex#map',
            zoom: zoom,
            controls: []
        }, {maxZoom: 17, minZoom: 0});

        ymap.behaviors.disable('scrollZoom');
        ymap.behaviors.disable('drag');
        ymap.controls.add('zoomControl', {left: '10px'});

        var l_collection = new maps.GeoObjectCollection();

        var l_Placemark = new maps.Placemark([parseFloat(set[0]), parseFloat(set[1])], {}, {
            iconLayout: "default#image",
            iconImageHref: "/build/images/map_alt.png",
            iconImageSize: [88, 81],
            iconImageOffset: [-34, -81],
            scrollwheel: false
        });
        l_collection.add(l_Placemark);

        if (l_collection.getLength() > 0) {
            ymap.geoObjects.add(l_collection);
        }
    })
    .catch(error => console.log('Failed to load Yandex Maps', error));
